import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f0f146a")

_pushScopeId("data-v-3f0f146a")
const _hoisted_1 = {
  class: "navbar--product uk-navbar",
  "uk-navbar": ""
}
const _hoisted_2 = { class: "uk-navbar-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "navbar__version" }, "Beta", -1)
const _hoisted_4 = {
  key: 0,
  class: "navbar__title body-3"
}
const _hoisted_5 = {
  key: 0,
  class: "uk-navbar-right"
}
const _hoisted_6 = {
  key: 1,
  class: "uk-navbar-right"
}
const _hoisted_7 = { id: "account-management" }
const _hoisted_8 = { class: "avatar body-3 uk-inline" }
const _hoisted_9 = { class: "uk-inline" }
const _hoisted_10 = { class: "email body-2" }
const _hoisted_11 = { class: "credits body-3" }
const _hoisted_12 = { class: "credits__amount" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "credits__link" }, "Get credits", -1)
const _hoisted_14 = {
  class: "container",
  "uk-dropdown": "mode: click; pos: bottom-justify; toggle: .chevron-down; boundary: #account-management; boundary-align: true;"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "dropdown__item body-2" }, "Get credits", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "dropdown__item body-2" }, "Account Settings", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Log out ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ThothButton = _resolveComponent("ThothButton")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/dashboard" }, {
        default: _withId(() => [
          _createVNode("img", {
            src: _ctx.thothLogo,
            alt: "thoth__logo"
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _hoisted_3,
      (['EDIT', 'PUBLISH'].includes(_ctx.stage))
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (['EDIT'].includes(_ctx.stage))
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: "image__icon",
                  src: _ctx.icons.undo,
                  alt: "undo-icon"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode("button", {
        class: ["undo__redo__button", { disabled: false }],
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redoVersionHandler && _ctx.redoVersionHandler(...args)))
      }, [
        (['EDIT'].includes(_ctx.stage))
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "image__icon",
              src: _ctx.icons.redo,
              alt: "redo-icon"
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      (['EDIT'].includes(_ctx.stage))
        ? (_openBlock(), _createBlock("button", {
            key: 1,
            class: "version__history__button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCloseVersionHistory && _ctx.openCloseVersionHistory(...args)))
          }, " View version history "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.stage === 'EDIT')
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_ThothButton, {
            text: "done!",
            colour: _ctx.ButtonColour.White,
            emphasis: _ctx.ButtonColour.Contained,
            size: _ctx.ButtonSize.M,
            onClick: _ctx.openPublishModal
          }, null, 8, ["colour", "emphasis", "size", "onClick"]),
          _createVNode(_component_Modal, {
            "modal-id": "publish__modal",
            "modal-title": "Done editing?",
            "modal-content": _ctx.modalText,
            image: _ctx.modalImage,
            "primary-button-text": "yes, i'm sure",
            "primary-button-action": _ctx.publishInfographic,
            "secondary-button-text": "continue editing",
            "secondary-button-action": _ctx.closePublishModal,
            preventBackgroundClick: ""
          }, null, 8, ["modal-content", "image", "primary-button-action", "secondary-button-action"])
        ]))
      : _createCommentVNode("", true),
    (['CREATE', 'PREVIEW', 'PUBLISH'].includes(_ctx.stage))
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.profile.firstName && _ctx.profile.lastName
              ? `${_ctx.profile.firstName.slice(0, 1)}${_ctx.profile.lastName.slice(
                  0,
                  1
                )}`
              : `${_ctx.user.email.slice(0, 2)}`), 1),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.profile.firstName && _ctx.profile.lastName
                ? _ctx.truncate(_ctx.profile)
                : _ctx.user.email), 1),
              _createVNode("div", _hoisted_11, [
                _createVNode("span", _hoisted_12, _toDisplayString(_ctx.user.credits) + " credits ∙ ", 1),
                _createVNode(_component_router_link, {
                  to: "/pricing",
                  target: "_blank"
                }, {
                  default: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode("img", {
              class: "chevron-down",
              src: _ctx.icons.chevronDownWhite,
              alt: "chevron__down"
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, {
              to: "/pricing",
              target: "_blank"
            }, {
              default: _withId(() => [
                _createVNode("img", {
                  src: _ctx.icons.credit,
                  alt: "credit__icon"
                }, null, 8, ["src"]),
                _hoisted_15
              ]),
              _: 1
            }),
            _hoisted_16,
            _createVNode(_component_router_link, { to: "/settings" }, {
              default: _withId(() => [
                _createVNode("img", {
                  src: _ctx.icons.settings,
                  alt: "settings__icon"
                }, null, 8, ["src"]),
                _hoisted_17
              ]),
              _: 1
            }),
            _hoisted_18,
            _createVNode("div", {
              class: "dropdown__logout body-2",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, [
              _createVNode("img", {
                src: _ctx.icons.logout,
                alt: "logout__icon"
              }, null, 8, ["src"]),
              _hoisted_19
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})